export enum SeverityType {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export enum ComponentType {
    Robots = 0,
    Transactions = 1,
    Triggers = 2,
    Jobs = 3,
    Process = 4,
    Tasks = 5,
    Queues = 6,
}

export enum NotificationState {
    Unread,
    Read,
}

export interface IAlert {
    id: number;
    name: string;
    component: 'Robots' | 'Transactions' | 'Triggers' | 'Jobs' | 'Process' | 'Tasks' | 'Queues';
    data: IAlertData;
    severity: number;
    timestamp: Date;
    state: string;
    userNotificationId: string;
    showDetails?: boolean;
    permissions?: string[];
}

export interface IAlertData {
    jobId?: number;
    queueItemId?: number;
    message: string;
    forceDisplay?: boolean;
    folderId?: boolean;
    folderFullyQualifiedName?: string;
}
